<div class="mx-auto max-w-md">
  <app-card>
    <form
      [formGroup]="registerForm"
      (ngSubmit)="registerUser()"
      class="space-y-5"
    >
      @if (showAlert) {
        <app-alert [severity]="severity" [message]="message" />
      }

      <div>
        <h1 class="text-xl font-bold text-fg">
          {{ isTrial ? 'Gratis proefles' : 'Aanmelden' }}
        </h1>
        <p class="mt-1 text-sm text-fg-muted">
          {{
            isTrial
              ? 'Probeer één les gratis. Je hebt geen chipnummer nodig.'
              : 'Maak je account aan met je chipnummer of de sign-up code.'
          }}
        </p>
      </div>

      <app-field label="E-mailadres" for="email" [control]="email">
        <input
          appInput
          [control]="email"
          formControlName="email"
          id="email"
          type="email"
          autocomplete="email"
          placeholder="jij@voorbeeld.be"
        />
      </app-field>

      <div class="grid gap-5 sm:grid-cols-2">
        <app-field label="Voornaam" for="firstName" [control]="firstName">
          <input
            appInput
            [control]="firstName"
            formControlName="firstName"
            id="firstName"
            autocomplete="given-name"
          />
        </app-field>

        <app-field label="Achternaam" for="lastName" [control]="lastName">
          <input
            appInput
            [control]="lastName"
            formControlName="lastName"
            id="lastName"
            autocomplete="family-name"
          />
        </app-field>
      </div>

      <app-field label="Wachtwoord" for="password" [control]="password">
        <input
          appInput
          [control]="password"
          formControlName="password"
          id="password"
          type="password"
          autocomplete="new-password"
        />
      </app-field>

      <app-field
        label="Herhaal wachtwoord"
        for="confirm_password"
        [control]="confirm_password"
      >
        <input
          appInput
          [control]="confirm_password"
          formControlName="confirm_password"
          id="confirm_password"
          type="password"
          autocomplete="new-password"
        />
      </app-field>

      @if (!isTrial) {
        <app-field
          label="Chipnummer of sign-up code"
          for="chipnumber"
          [control]="chipnumber"
        >
          <input
            appInput
            [control]="chipnumber"
            formControlName="chipnumber"
            id="chipnumber"
          />
        </app-field>
      }

      <!-- min-h-11: the wording now fits on one line, and the label is the tap target. -->
      <label
        for="checkbox"
        class="flex min-h-11 cursor-pointer items-center gap-3 py-2"
      >
        <input
          appCheckbox
          type="checkbox"
          id="checkbox"
          formControlName="readPrivacyStatement"
        />
        <!-- "Gelezen", not "akkoord": this asked people to agree to algemene voorwaarden
             that do not exist, behind a link to the privacy statement. A privacy
             statement is also not something to agree to -- the statement itself names
             the contract and our legal obligations as the grounds, never consent, so a
             tick cannot add or withdraw anything. What it does is record that the
             information was put in front of the member, which is what GDPR asks for. -->
        <span class="text-sm text-fg-muted">
          Ik heb de
          <a
            routerLink="/privacybeleid"
            target="_blank"
            class="font-semibold text-fg hover:text-brand hover:underline"
          >
            privacyverklaring
          </a>
          gelezen
        </span>
      </label>

      <button
        appButton
        type="submit"
        class="w-full"
        [disabled]="
          registerForm.invalid || registerForm.pending || inSubmission
        "
      >
        {{ isTrial ? 'Gratis proefles reserveren' : 'Account aanmaken' }}
      </button>

      <p class="text-sm text-fg-muted">
        Al een account?
        <a
          routerLink="/login"
          class="font-semibold text-fg hover:text-brand hover:underline"
        >
          Inloggen
        </a>
      </p>

      @if (!isTrial) {
        <p class="text-sm text-fg-muted">
          Nog geen lid?
          <a
            routerLink="/proefles"
            class="font-semibold text-fg hover:text-brand hover:underline"
          >
            Kom eerst gratis proberen
          </a>
        </p>
      } @else {
        <p class="text-sm text-fg-muted">
          Al lid van de club?
          <a
            routerLink="/aanmelden"
            class="font-semibold text-fg hover:text-brand hover:underline"
          >
            Registreer je als lid
          </a>
        </p>
      }
    </form>
  </app-card>
</div>
